<form-popup [(visible)]="visible" (visibleChange)="onVisibleChange($event)"
            (save)="onPopupSaveClick()"
            (open)="onOpen()"
            titleText="Edit Shift">
    <shift-form [data]="formData"></shift-form>
</form-popup>
